import AccountDetails from './AccountDetails';
import HttpResponse from './HttpResponse';

class AccountDetail extends HttpResponse {
  public accountDetails: AccountDetails;
}

export default AccountDetail;
